import React, { useEffect, useState } from "react";
import { FaCheck, FaInfoCircle, FaTimes } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { CDN_BASE_URL, YOUTUBE_CHANNEL } from "../../config";
import Loading from "../common/Loading";
import axios from "axios";

const YoutubeCommentTask = ({ user, reward, loading, setuser }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [discordLoading, setDiscordLogin] = useState(false);

  const handleDiscordLogin = () => {
    localStorage.setItem("youtubeComment", "true");
    window.location.href = CDN_BASE_URL + "auth/google";
  };

  useEffect(() => {
    const checkDiscordReturn = async () => {
      setDiscordLogin(true);
      const isReturningFromDiscord = localStorage.getItem("youtubeComment");
      if (isReturningFromDiscord) {
        try {
          const response = await axios.get(
            CDN_BASE_URL + "youtube/comment/user/" + user?._id,
            {
              withCredentials: true,
            }
          ); // API مورد نظر تو
          setuser(response.data);
          // موفقیت‌آمیز، حالا فلگ را پاک کن
          localStorage.removeItem("youtubeComment");
          // شاید نیاز به رفرش دیتا یا redirect داشته باشی
        } catch (err) {
          localStorage.removeItem("youtubeComment");
        }
      }
      setDiscordLogin(false);
    };

    checkDiscordReturn();
  }, []);

  return (
    <div
      className={`${
        user?.youtubeComment?.isDoes && "order-last opacity-40"
      } flex justify-between gap-3 items-center relative py-2 pb-4 border-b`}
    >
      <span className="flex items-center gap-2 lg:gap-4">
        <FaYoutube className="text-[32px] sm:text-[54px] lg:text-[72px]" />
        <span>
          <h4 className="font-bold text-[14px] lg:text-[28px] lg:-mb-2 flex items-center gap-2">
            Comment on Our Youtube Videos
            {/* <FaInfoCircle
              className="text-blue-400 cursor-pointer"
              onClick={() => setIsModalOpen(true)}
              title="Help"
            /> */}
          </h4>
          <span className="font-bold text-[16px] lg:text-[28px] flex gap-1 items-center">
            <img src="/gold.png" className="w-6 lg:w-8" alt="GOLD" />+{reward}
          </span>
        </span>
      </span>

      {discordLoading ? (
        <button
          disabled
          className="start-button px-4 lg:px-8 py-2 bg-[#02006A] shadow shadow-white/40 rounded-full text-[14px] lg:text-[24px] flex gap-2 items-center"
        >
          Loading...
        </button>
      ) : loading ? (
        <button
          onClick={handleDiscordLogin}
          disabled={user?.youtubeComment?.isDoes}
          className="start-button px-4 lg:px-8 py-2 bg-[#02006A] shadow shadow-white/40 rounded-full text-[14px] lg:text-[24px] flex gap-2 items-center"
        >
          Loading...
        </button>
      ) : user?.youtubeComment?.isDoes ? (
        <button
          onClick={handleDiscordLogin}
          disabled={user?.youtubeComment?.isDoes}
          className="start-button px-4 lg:px-8 py-2 bg-[#02006A] shadow shadow-white/40 rounded-full text-[14px] lg:text-[24px] flex gap-2 items-center"
        >
          <FaCheck color="green" /> Claimed
        </button>
      ) : (
        <span className="flex flex-wrap gap-2 justify-end">
          <Link
            target="_blank"
            to={YOUTUBE_CHANNEL}
            className="start-button px-4 lg:px-8 py-2 bg-[#02006A] shadow shadow-white/40 rounded-full text-[14px] lg:text-[24px] flex gap-2 items-center"
          >
            Start
          </Link>
          <button
            onClick={handleDiscordLogin}
            disabled={user?.youtubeComment?.isDoes}
            className="start-button px-4 lg:px-8 py-2 bg-[#02006A] shadow shadow-white/40 rounded-full text-[14px] lg:text-[24px] flex gap-2 items-center"
          >
            Check
          </button>
        </span>
      )}

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50">
          <div className="bg-[#1e293b] rounded-xl max-w-[90%] w-full sm:w-[600px] p-4">
            <div className="flex justify-between items-center mb-4 text-white">
              <h2 className="text-xl font-bold ">How to Complete This Task</h2>
              <button
                onClick={() => setIsModalOpen(false)}
                className="text-lg font-bold"
              >
                <FaTimes />
              </button>
            </div>
            <div className="aspect-video mb-4">
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/ryX6ZhI5qY4"
                title="YouTube Tutorial"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <p className="text-gray-300 text-center">
              <strong>Note:</strong> Your subscriptions must be public to
              complete this task.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default YoutubeCommentTask;
